import axios from 'axios';
import { SessionExpiredError } from './SessionExpiredError';

/**
 * Servicio para submit final del trámite
 * Actualiza el estado en Redis a 'submitted'
 */

/**
 * Envía el trámite completo al backend
 * @param {Object} tramiteData - Datos del trámite (sin token)
 * @param {string} sessionToken - Token de sesión del trámite
 * @returns {Promise<Object>} Respuesta del servidor
 */
export const submitTramite = async (tramiteData, sessionToken) => {
  try {
    const response = await axios.post('/v1/sat/tramites/submit', tramiteData, {
      headers: {
        Authorization: `Bearer ${sessionToken}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error('Error al enviar trámite:', error);

    const statusCode = error.response?.status;
    const message = error.response?.data?.error;
    const isTokenInvalidOrExpired =
      message?.toLowerCase().includes('token') &&
      (message?.toLowerCase().includes('inválido') || message?.toLowerCase().includes('expirado'));

    if (statusCode === 422 && isTokenInvalidOrExpired) {
      throw new SessionExpiredError(statusCode, message);
    }

    throw new Error(message || error.message || 'Error al enviar el trámite');
  }
};
